// components/organization/OrgResultsPreview.jsx
import { useTranslation } from "react-i18next"; // ← اضافه شده

const OrgResultsPreview = ({ results }) => {
  const { t } = useTranslation(); // ← اضافه شده

  return (
    <div className="bg-white rounded-xl shadow p-4">
      <h3 className="text-lg font-semibold text-gray-800 mb-4">
        {t('org_results_preview.title')}
      </h3>
      {results.length ? (
        <ul className="divide-y text-sm">
          {results.map((item, i) => (
            <li
              key={i}
              className="py-2 flex justify-between items-center border-b border-gray-100"
            >
              <div className="flex flex-col">
                <span className="font-medium text-gray-800">{item.name}</span>
                <span className="text-gray-500 text-xs">{item.exam}</span>
              </div>
              <span className="bg-indigo-100 text-indigo-700 text-sm font-bold px-3 py-1 rounded-full">
                {item.score}
              </span>
            </li>
          ))}
        </ul>
      ) : (
        <p className="text-gray-500 text-sm">{t('org_results_preview.empty_state_message')}</p>
      )}
    </div>
  );
};

export default OrgResultsPreview;